import { createContext } from 'react';
import type { Role } from '../types/roles';

export interface Session {
  uid: string;
  email: string | null;
  displayName: string | null;
  /** From custom claims. A member holds several. */
  roles: Role[];
  orgId: string | null;
  /**
   * A platform system administrator (the isSysAdmin claim): the console,
   * every organization. An organization's own System Admin has the
   * `sysadmin` role in `roles` and this false.
   */
  platformSysAdmin: boolean;
}

export interface AuthState {
  /** True until Firebase has told us whether anyone is signed in. */
  loading: boolean;
  session: Session | null;
  signOut: () => Promise<void>;
  /** Re-reads custom claims, forcing a token refresh. Call after a role change. */
  refresh: () => Promise<void>;
}

export const AuthContext = createContext<AuthState | null>(null);
